import React from "react";
import DashboardSearchInput from "./DashboardSearchInput";
import DashboardSearchBar from "./DashboardSearchBar";
import { CommunityInfo } from "./DashboardSearchFooterStyle";
import DashboardSearchRecommend from "./DashboardSearchRecommend";
import styled from "styled-components";

const DashboardSearchNoResult = () => {
  return (
    <div>
      <NoResultWrapper>
        <p>검색결과가 없습니다.</p>
        <p>검색어를 다시 한번 확인해 보세요</p>
      </NoResultWrapper>
      <DashboardSearchRecommend />
    </div>
  );
};

export default DashboardSearchNoResult;

const NoResultWrapper = styled.div`
  width: 100%;
  margin: 80px 0 80px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  p {
    font-weight: 400;
    color: #222529;
    font-size: 0.875rem;
    max-width: 250px;
  }
`;
